import React from 'react'
import styles from "../../styles/components/profileform.module.scss";
import { Box, Typography } from '@mui/material';


export default function ProfileForm({formHeader,children}) {
  return (
    <Box className={styles.form_outr} >
        <Typography variant="h4" >{formHeader}</Typography>
        <Box className={styles.form_inr} >
              {children}
        </Box>
    </Box>
  )
}
